import React, { ComponentType } from 'react';
import { useI18n } from '@monorepo/i18n';
import { classNameProp } from '@monorepo/type';
import {
  DataTable,
  Cell,
  Row,
  Head,
  Body,
  columnData,
  rowData
} from '@monorepo/ui-kit';
import FormRow from './FormRow';

import styles from './index.module.css';

type tableProps = {
  data: rowData[];
  columns: columnData[];
  isWithHeader?: boolean;
  rowKey?: string;
  round?: boolean;
  rowKeyData: string;
  CollapseRow?: ComponentType<any>;
} & classNameProp;

const CollapseTable = ({
  data,
  columns,
  isWithHeader = true,
  className = '',
  rowKey = 'id',
  round = false,
  rowKeyData
}: tableProps) => {
  const { t } = useI18n();

  return (
    <DataTable
      className={`${styles.table} ${className} ${round ? styles.round : ''}`}
    >
      {isWithHeader && (
        <Head className={styles.head}>
          <Row>
            {columns.map(
              ({ accessor, HeaderComponent, header = '', cellClass = '' }) => (
                <Cell
                  className={`${styles.th} ${cellClass}`}
                  scope="col"
                  key={`th-${accessor}`}
                >
                  {HeaderComponent ? <HeaderComponent /> : t(header)}
                </Cell>
              )
            )}
          </Row>
        </Head>
      )}
      <Body>
        {data.map((row) => (
          <FormRow
            row={row}
            key={row.id}
            columns={columns}
            rowKeyData={rowKeyData}
          />
        ))}
      </Body>
    </DataTable>
  );
};

export default CollapseTable;
